import { hasMoreRushWithinLastFrequencyTime } from '@/src/components/OrderCommon/utils';
import { ORDERBTN_CODE, ORDER_DELIVERY_STATUS, ORDER_STATUS_SOURCE } from '../../../../../components/OrderCommon/constant';
import { OrderDetailData, OrderStatusData } from '../interface';

const Statistics = Mach.requireModule('Statistics');

interface Value {
  [key: string]: any;
}

/// 页面 CID
export const OrderStatusPageCID = 'c_waimai_c_overseas_vl9a52s8';

const mv = (bid: string, val: Value = {}) => {
  Statistics.view(OrderStatusPageCID, bid, val);
};

const mc = (bid: string, val: Value = {}) => {
  const safeVal = typeof val === 'object' ? val : {};
  Statistics.setTag('sailor_c', { [OrderStatusPageCID]: { bid, ...safeVal } });
  Statistics.click(OrderStatusPageCID, bid, val);
};
/// BID
export const OrderStatusBID = {
  // 返回
  backClick: 'b_waimai_c_overseas_m3baokqr_mc',
  // 客服
  kefuView: 'b_waimai_c_overseas_h30i958d_mv',
  kefuClick: 'b_waimai_c_overseas_h30i958d_mc',
  // 地图
  mapView: 'b_waimai_c_overseas_zp57704b_mv',
  mapButtonView: 'b_waimai_c_overseas_cvfap8mt_mv',
  mapButtonClick: 'b_waimai_c_overseas_cvfap8mt_mc',
  // 操作区 按钮
  oButtonView: 'b_waimai_c_overseas_esy7dc62_mv',
  oButtonClick: 'b_waimai_c_overseas_esy7dc62_mc',
  oButtonApplyRrefundView: 'b_waimai_c_overseas_hif3c9tv_mv',
  oButtonApplyRrefundClick: 'b_waimai_c_overseas_hif3c9tv_mc',

  moreOrderInfoView: 'b_waimai_c_overseas_wcvhrokj_mv',
  moreOrderInfoClick: 'b_waimai_c_overseas_wcvhrokj_mc',
  // 轮播卡片mv/mc
  marketingBannerItemView: 'b_sailor_c_uvf7xij4_mv',
  marketingBannerItemClick: 'b_sailor_c_uvf7xij4_mc',

  // 调用Store评论引导
  storeReviewView: 'b_sailor_c_fcca0tga_mv',

  // 评价按钮入口
  evaluateBtnView: 'b_sailor_c_rctiraq0_mv',
  evaluateBtnClick: 'b_sailor_c_rctiraq0_mc',
  // 查看评价按钮入口
  reviewEvaluateBtnView: 'b_sailor_c_nb5bjf2a_mv',
  reviewEvaluateBtnClick: 'b_sailor_c_nb5bjf2a_mc',
  // 大订单提示 MV
  largeOrderTipsView: 'b_sailor_c_9s5de124_mv',

  // 大订单包裹卡片 MV
  largeOrderPackageCardView: 'b_sailor_c_t1swrfwl_mv',

  // 大订单包裹卡片-按钮 MV
  largeOrderPackageCardButtonView: 'b_sailor_c_0fe7n133_mv',
  // 大订单包裹卡片-按钮 MC
  largeOrderPackageCardButtonClick: 'b_sailor_c_0fe7n133_mc',

  // 评价浮窗
  evaluatePopupViewMV: 'b_sailor_c_l71hhdjm_mv',
  evaluatePopupViewMC: 'b_sailor_c_l71hhdjm_mc',
  // 评价浮窗关闭按钮
  evaluatePopupViewCloseMC: 'b_sailor_c_1ycrwo9g_mc',

  // 催单按钮曝光
  orderRushMV: 'b_sailor_c_dxtrf6o0_mv',
  // 催单按钮点击
  orderRushMC: 'b_sailor_c_dxtrf6o0_mc',

  // 是否收餐浮窗
  deliveryFeedbackReceiveMV: 'b_sailor_c_t7usjsjd_mv',
  deliveryFeedbackReceiveMC: 'b_sailor_c_t7usjsjd_mc',
  deliveryFeedbackReceiveClose: 'b_sailor_c_pfbe377c_mc',
  // 未送达浮窗
  deliveryFeedbackUnreceiveMV: 'b_sailor_c_lr5r84up_mv',
  deliveryFeedbackUnreceiveMC: 'b_sailor_c_lr5r84up_mc',
  deliveryFeedbackUnreceiveClose: 'b_sailor_c_29ryma90_mc',
  pickupNavigntionMc: 'b_sailor_c_eky6uytb_mc',
};

// 缓存
let OButtonCacheMap: any = {};

let kDetailData: OrderDetailData;
let kStatusData: OrderStatusData;

// pv
export function orderStatusPV(statusData, detailData, largeOrderStatus) {
  // 重置
  OButtonCacheMap = {};
  kDetailData = detailData;
  kStatusData = statusData;

  const orderStatus = kStatusData?.orderOperateInfo?.orderStatusInfo?.orderStatus;
  const orderViewId = kDetailData?.orderBaseInfo?.orderViewId;
  const afterSaleStatus = kStatusData?.refundList ? (kStatusData?.refundList[0]?.afterSaleStatus || 0) : (kStatusData?.refundInfo?.afterSaleStatus || 0);
  let refundType = kStatusData?.refundList ? (kStatusData?.refundList?.length > 1 ? 0 : kStatusData?.refundList[0]?.afterSaleType) : (kStatusData?.refundInfo?.afterSaleType || '');

  const source = Mach.env.schemeParams?.source;
  let pageSource = '2';
  if (ORDER_STATUS_SOURCE.CONFIRM === source) {
    pageSource = '0';
  } else if (ORDER_STATUS_SOURCE.LIST === source) {
    pageSource = '1';
  }
  if (!refundType) {
    refundType = '-999';
  }
  const userGetMode = kStatusData?.userGetMode ?? '-999';
  const val = {
    order_status: orderStatus,
    order_view_id: orderViewId,
    refund_status: afterSaleStatus,
    page_source: pageSource,
    refund_type: refundType,
    large_order_status: largeOrderStatus,
    user_get_mode: userGetMode
  };
  Statistics.pv(OrderStatusPageCID, val);
}

// 返回
export function orderStatusBackClick() {
  Statistics.click(OrderStatusPageCID, OrderStatusBID.backClick);
}

function kLab(largeOrderStatus?: number) {
  const val: Value = {};

  // 运单号
  const waybillId = kStatusData?.deliveryMapInfo?.waybillId || '-999';
  // 订单状态
  const orderStatus = kStatusData?.orderOperateInfo?.orderStatusInfo?.orderStatus;
  // 订单号
  const orderViewId = kDetailData?.orderBaseInfo?.orderViewId;
  // 退款状态
  const afterSaleStatus = kStatusData?.refundList ? (kStatusData?.refundList[0]?.afterSaleStatus || 0) : (kStatusData?.refundInfo?.afterSaleStatus || 0);
  const userGetMode = kStatusData.userGetMode ?? '';
  val.delivery_order_id = waybillId;
  if (orderStatus) {
    val.order_status = orderStatus;
  }
  if (orderViewId) {
    val.order_view_id = orderViewId;
  }
  val.refund_status = afterSaleStatus;
  val.large_order_status = largeOrderStatus;
  val.user_get_mode = userGetMode;
  return val;
}

/**
 * 获取客服灵犀埋点
 */
function getCSLxLab(largeOrderStatus) {
  const commonParams = kLab(largeOrderStatus);
  const bubble_read_status = kStatusData?.userCsInfo?.unReadCount > 0 ? 2 : 1;
  const lxLab = { bubble_read_status, ...commonParams };
  return lxLab;
}

// 客服 view
export function orderStatusKefuView(largeOrderStatus?: number) {
  if (OButtonCacheMap[OrderStatusBID.kefuView]) {
    return;
  }
  OButtonCacheMap[OrderStatusBID.kefuView] = OrderStatusBID.kefuView;
  Statistics.view(OrderStatusPageCID, OrderStatusBID.kefuView, getCSLxLab(largeOrderStatus));
}

// 客服 clickb_sailor_c_0j0nr3zj_mv
export function orderStatusKefuClick(largeOrderStatus?: number) {
  Statistics.click(OrderStatusPageCID, OrderStatusBID.kefuClick, getCSLxLab(largeOrderStatus));
}

// 地图 view
export function orderStatusMapView(mapStatus: number, largeOrderStatus?: number) {
  const lab = kLab(largeOrderStatus);
  lab.map_status = mapStatus;
  Statistics.view(OrderStatusPageCID, OrderStatusBID.mapView, lab);
}

// 操作区按钮 view
export function orderStatusOButtonView(buttonCode: any, isRedDot?: number, largeOrderStatus?: number) {
  if (OButtonCacheMap[buttonCode]) {
    return;
  }
  OButtonCacheMap[buttonCode] = buttonCode;
  const userGetMode = kStatusData?.userGetMode ?? '-999';
  // 评价、查看评价埋点
  const reviewLab = {
    order_view_id: kDetailData?.orderBaseInfo?.orderViewId ?? '-999',
    entry_type: 1,
    shop_evaluate: '-999',
    user_get_mode: userGetMode
  };
  if (ORDERBTN_CODE.EVALUATE === buttonCode) {
    Statistics.view(OrderStatusPageCID, OrderStatusBID.evaluateBtnView, reviewLab);
  } else if (ORDERBTN_CODE.REVIEW_EVALUATE === buttonCode) {
    Statistics.view(OrderStatusPageCID, OrderStatusBID.reviewEvaluateBtnView, reviewLab);
  } else {
    let lab = kLab(largeOrderStatus);
    lab.button_code = buttonCode;
    lab.is_red_dot = 0;

    let bid = OrderStatusBID.oButtonView;
    if (ORDERBTN_CODE.APPLY_REFUND === buttonCode) {
      bid = OrderStatusBID.oButtonApplyRrefundView;
    }
    if (ORDERBTN_CODE.IM === buttonCode) {
      lab = { ...lab, is_red_dot: isRedDot };
    }
    Statistics.view(OrderStatusPageCID, bid, lab);
  }
}

// 操作区按钮 click
export function orderStatusOButtonClick(buttonCode: any, isRedDot?: number, largeOrderStatus?: number) {
  // 评价、查看评价埋点
  const userGetMode = kStatusData.userGetMode ?? '';
  const reviewLab = {
    order_view_id: kDetailData?.orderBaseInfo?.orderViewId ?? '-999',
    entry_type: 1,
    shop_evaluate: '-999',
    user_get_mode: userGetMode
  };
  if (ORDERBTN_CODE.EVALUATE === buttonCode) {
    Statistics.click(OrderStatusPageCID, OrderStatusBID.evaluateBtnClick, reviewLab);
  } else if (ORDERBTN_CODE.REVIEW_EVALUATE === buttonCode) {
    Statistics.click(OrderStatusPageCID, OrderStatusBID.reviewEvaluateBtnClick, reviewLab);
  } else {
    let lab = kLab(largeOrderStatus);
    lab.button_code = buttonCode;
    lab.is_red_dot = 0;
    let bid = OrderStatusBID.oButtonClick;
    if (ORDERBTN_CODE.APPLY_REFUND === buttonCode) {
      bid = OrderStatusBID.oButtonApplyRrefundClick;
    }
    if (ORDERBTN_CODE.IM === buttonCode) {
      lab = { ...lab, is_red_dot: isRedDot };
    }
    Statistics.click(OrderStatusPageCID, bid, lab);
  }
}

// 查看更多订单信息
export function moreOrderInfoLXView() {
  mv(OrderStatusBID.moreOrderInfoView, kLab());
}

// 点击查看订单信息
export function didSelectedMoreOrderInfoLXMC() {
  mc(OrderStatusBID.moreOrderInfoClick, kLab());
}

// 准时保曝光
const punctualMv = (val) => {
  mv('b_sailor_c_c1yk9gkg_mv', val);
};

// 准时保点击
const punctualMc = (val) => {
  mc('b_sailor_c_c1yk9gkg_mc', val);
};

// 取消订单确认弹窗曝光
export function cancelOrderPopupLxView(val) {
  mv('b_sailor_c_6u36dz96_mv', val);
}

// 点击取消订单弹层按钮
export function cancelOrderPopupBtnClick(val) {
  mc('b_sailor_c_6u36dz96_mc', val);
}

// 进度条曝光
const progressBarMv = (val) => {
  mv('b_sailor_c_0j0nr3zj_mv', val);
};

// 营销轮播卡片item曝光
const marketingBannerItemMv = (bid: string, lab?: object) => {
  mv(bid, lab);
};

// 营销轮播卡片item点击
const marketingBannerItemMc = (bid: string, lab?: object) => {
  mc(bid, lab);
};

export {
  punctualMv, punctualMc, progressBarMv, marketingBannerItemMv, marketingBannerItemMc
};

// 订单详情页-退款进度条曝光
export function refundProcessBarMv(val) {
  mv('b_sailor_c_izxpnbvy_mv', val);
}
// 订单详情页-退款进度条点击
export function refundProcessBarMc(val) {
  mc('b_sailor_c_izxpnbvy_mc', val);
}
// 订单详情页-商品卡片退款进度提示曝光
export function refundItemBarMv(val) {
  mv('b_sailor_c_t4rsozxf_mv', val);
}
// 订单详情页-商品卡片退款进度提示点击
export function refundItemBarMc(val) {
  mc('b_sailor_c_t4rsozxf_mc', val);
}

// 多单任务参与弹窗曝光
export function participateDialogMv(val) {
  mv('b_sailor_c_zyx263x2_mv', val);
}

// 多单任务参与弹窗点击
export function participateDialogMc(val) {
  mc('b_sailor_c_zyx263x2_mc', val);
}

// 多单任务参与弹窗-查看详情
export function participateDialogDetailButtonMc(val) {
  mc('b_sailor_c_nokm9525_mc', val);
}

// 多单任务预达标弹窗曝光
export function getCouponDialogMv(val) {
  mv('b_sailor_c_7jp91kd4_mv', val);
}

// 多单任务预达标弹窗点击
export function getCouponDialogMc(val) {
  mc('b_sailor_c_7jp91kd4_mc', val);
}
// 多单任务预达标弹窗-查看详情
export function getCouponDialogDetailButtonMc(val) {
  mc('b_sailor_c_fgqtjjk1_mc', val);
}
// 调用市场评论引导，因Store有黑盒限频规则，不一定真能展示
export function storeReviewMv() {
  mv(OrderStatusBID.storeReviewView, kLab());
}

export function largeOrderTipsMv(val) {
  if (OButtonCacheMap[OrderStatusBID.largeOrderTipsView]) {
    return;
  }
  OButtonCacheMap[OrderStatusBID.largeOrderTipsView] = OrderStatusBID.largeOrderTipsView;
  mv(OrderStatusBID.largeOrderTipsView, val);
}

export function remarkMv() {
  const val = kLab();
  mv('b_sailor_c_g7vb1pzc_mv', val);
}
export function largeOrderCardMv(val) {
  const lab = {
    ...kLab(),
    ...val
  };
  mv(OrderStatusBID.largeOrderPackageCardView, lab);
}

export function largeOrderCardButtonMv(val) {
  const lab = {
    ...kLab(),
    ...val
  };
  mv(OrderStatusBID.largeOrderPackageCardButtonView, lab);
}

export function largeOrderCardButtonMc(val) {
  const lab = {
    ...kLab(),
    ...val
  };
  mc(OrderStatusBID.largeOrderPackageCardButtonClick, lab);
}

export function evaluatePopupViewMV(val) {
  mv(OrderStatusBID.evaluatePopupViewMV, val);
}

export function evaluatePopupViewMC(val) {
  mc(OrderStatusBID.evaluatePopupViewMC, val);
}

export function evaluatePopupViewCloseMC(val) {
  mc(OrderStatusBID.evaluatePopupViewCloseMC, val);
}

// 是否送达反馈
export function deliveryFeedbackReceiveMV(val) {
  mv(OrderStatusBID.deliveryFeedbackReceiveMV, val);
}

export function deliveryFeedbackReceiveMC(val) {
  mc(OrderStatusBID.deliveryFeedbackReceiveMC, val);
}

export function deliveryFeedbackReceiveCloseMC(val) {
  mc(OrderStatusBID.deliveryFeedbackReceiveClose, val);
}

// 未送达反馈
export function deliveryFeedbackUnreceiveMV(val) {
  mv(OrderStatusBID.deliveryFeedbackUnreceiveMV, val);
}

export function deliveryFeedbackUnreceiveMC(val) {
  mc(OrderStatusBID.deliveryFeedbackUnreceiveMC, val);
}
export function deliveryFeedbackUnreceiveCloseMC(val) {
  mc(OrderStatusBID.deliveryFeedbackUnreceiveClose, val);
}

// 催单按钮曝光
export function orderRushButtonMV(val) {
  mv(OrderStatusBID.orderRushMV, val);
}

// 催单按钮点击
export function orderRushButtonMC(val) {
  mc(OrderStatusBID.orderRushMC, val);
}

export function orderPickupNavigntionMc(val) {
  mc(OrderStatusBID.pickupNavigntionMc, val);
}
